var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a20a61ade5842ad1a1652f4fa549f3bda58118cc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["syntho-mobile@syntho"]={id:"a20a61ade5842ad1a1652f4fa549f3bda58118cc"};
      